import React from "react";
import { Grid } from "@mui/material/";
import AssetAttributes from "../AssetDetail/AssetAttributes";
import Core from "../AssetDetail/Core";
import Edit from "./Edit";
import { useAuditStatus } from "../../../../common/hooks";

type Props = {
    altAsset: any,
    attributes: Array<any>
};

/**
 * Alt-asset Detail Component
 */
export default ({ altAsset, attributes }) => {
    const auditStatus = useAuditStatus().id;
    /** Audit is editable if it is
     * Partially complete count status id 3
     * Pending Review status id 4
     * In review status id 5
     */
    const isEditable = [3, 4, 5].includes(auditStatus);

    return (
        <>
            {!altAsset.isResolved && isEditable && <Edit />}
            <Grid container>
                <Core {...altAsset} />
            </Grid>
            <Grid container>
                <AssetAttributes
                    assetTypeId={altAsset.type}
                    attributes={attributes}
                />
            </Grid>
        </>
    );
};
